import { fork, takeEvery, all } from 'redux-saga/effects';
import {
  AccountControllerDtoAccountCurrentNicknameUpdateRequest,
  AccountControllerDtoAccountCurrentPowerUpdateRequest,
  AccountControllerDtoAccountDefaultInfoRequest,
  AccountControllerDtoAccountInventoryInfoRequest,
  AccountControllerDtoAccountListRequest,
  AccountControllerDtoAccountPunishStatusUpdateRequest, AccountControllerDtoWithdrawalCancelRequest,
  AccountControllerDtoWithdrawalRequest,
  PerplayAccountApi,
} from '../../models/src';
import config from '../../../config/config';

import {
  ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST,
  ACCOUNT_CURRENT_POWER_UPDATE_REQUEST,
  ACCOUNT_DEFAULT_INFO_REQUEST, ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST,
  ACCOUNT_INVENTORY_INFO_REQUEST,
  ACCOUNT_LIST_REQUEST,
  ACCOUNT_PUNISH_STATUS_UPDATE, ACCOUNT_WITHDRAWAL_CANCEL_REQUEST,
} from '../../constants/user/perplayUserConstants';
import BaseResponse from '../../models/src/model/BaseResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import AccountControllerDtoAccountListResponse from '../../models/src/model/AccountControllerDtoAccountListResponse';
import AccountControllerDtoAccountDefaultInfoResponse
  from '../../models/src/model/AccountControllerDtoAccountDefaultInfoResponse';
import AccountControllerDtoAccountInventoryInfoResponse
  from '../../models/src/model/AccountControllerDtoAccountInventoryInfoResponse';

const api = new PerplayAccountApi(config.API_CLIENT);

//= ====================================
//  WATCHERS
//-------------------------------------
function* accountListRequestSaga(payload) {
  try {
    const requestData = new AccountControllerDtoAccountListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchString = payload.searchString || "";
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountAccountListPost({ accountControllerDtoAccountListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, AccountControllerDtoAccountListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* accountDefaultInfoRequestSaga(payload) {
  try {
    const result = yield api.apiPerplayAccountAccountDefaultInfoPost({ accountControllerDtoAccountDefaultInfoRequest: new AccountControllerDtoAccountDefaultInfoRequest(payload.accountNo) }, () => {});
    const data = api.apiClient.deserialize(result, AccountControllerDtoAccountDefaultInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* accountInventoryInfoRequestSaga(payload) {
  try {
    const result = yield api.apiPerplayAccountAccountInventoryInfoPost({ accountControllerDtoAccountInventoryInfoRequest: new AccountControllerDtoAccountInventoryInfoRequest(payload.accountNo) }, () => {});
    const data = api.apiClient.deserialize(result, AccountControllerDtoAccountInventoryInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* accountPunishStatusUpdateSaga(payload) {
  try {
    const requestData = new AccountControllerDtoAccountPunishStatusUpdateRequest();
    requestData.accountNo = payload.accountNo;
    requestData.reasonSort = payload.reasonSort;
    requestData.period = payload.period;
    requestData.reason = payload.reason;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountAccountPunishStatusUpdatePost({ accountControllerDtoAccountPunishStatusUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* accountCurrentPowerUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new AccountControllerDtoAccountCurrentPowerUpdateRequest();
    requestData.accountNo = payload.accountNo;
    requestData.currentPower = payload.currentPower;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountAccountCurrentPowerUpdatePost({ accountControllerDtoAccountCurrentPowerUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* accountCurrentNickNameUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new AccountControllerDtoAccountCurrentNicknameUpdateRequest();
    requestData.accountNo = payload.accountNo;
    requestData.oldNickname = payload.oldNickname;
    requestData.newNickname = payload.newNickname;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountAccountCurrentNicknameUpdatePost({ accountControllerDtoAccountCurrentNicknameUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* accountImmediateWithdrawalRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new AccountControllerDtoWithdrawalRequest();
    requestData.accountNo = payload.accountNo;
    requestData.reason = payload.reason;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountWithdrawalPost({ accountControllerDtoWithdrawalRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* accountWithdrawalCancelRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new AccountControllerDtoWithdrawalCancelRequest();
    requestData.accountNo = payload.accountNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayAccountWithdrawalCancelPost({ accountControllerDtoWithdrawalCancelRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* perplayUserRootSaga() {
  yield all([
    takeEvery(ACCOUNT_LIST_REQUEST, accountListRequestSaga),
    takeEvery(ACCOUNT_DEFAULT_INFO_REQUEST, accountDefaultInfoRequestSaga),
    takeEvery(ACCOUNT_INVENTORY_INFO_REQUEST, accountInventoryInfoRequestSaga),
    takeEvery(ACCOUNT_PUNISH_STATUS_UPDATE, accountPunishStatusUpdateSaga),
    takeEvery(ACCOUNT_CURRENT_POWER_UPDATE_REQUEST, accountCurrentPowerUpdateRequestSaga),
    takeEvery(ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST, accountCurrentNickNameUpdateRequestSaga),
    takeEvery(ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST, accountImmediateWithdrawalRequestSaga),
    takeEvery(ACCOUNT_WITHDRAWAL_CANCEL_REQUEST, accountWithdrawalCancelRequestSaga),
  ]);
}

const perplayUserSagas = [fork(perplayUserRootSaga)];

export default perplayUserSagas;
